import { render, staticRenderFns } from "./AreaNotifications.vue?vue&type=template&id=b799dab0&scoped=true&"
import script from "./AreaNotifications.vue?vue&type=script&lang=js&"
export * from "./AreaNotifications.vue?vue&type=script&lang=js&"
import style0 from "./AreaNotifications.vue?vue&type=style&index=0&id=b799dab0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b799dab0",
  null
  
)

export default component.exports